import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👨🏻‍💻</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">Seja bem vindo(a) !</p>
            <h1 className="head-text">Sou o Dé</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex">
          <p className="p-text">⌨️ Resolvendo <strong>problemas</strong> com <strong>tecnologia</strong></p>
        </div> <div className="tag-cmp app__flex">
          <p className="p-text">⌨ Sou um <strong>engenheiro de software</strong> dedicado e profissional, com quatro anos de experiência construindo <strong>soluções digitais em diversas stacks.</strong> Minha principal especialidade é desenvolvimento mobile com Flutter, aliado a sólida experiência em backend com Node.js e crescente atuação em IA e automações usando Python e n8n.</p>
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.eu_novo} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.node, images.flutter, images.react].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="profile_bg" />
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, 'olá');
